package org.gstechnovos.jexonplastech.sections.home.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val QualityStandardsContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.fillMaxWidth().backgroundColor(palette.custom.white)
    }
}

val QualityCardStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.padding(32.px).borderRadius(16.px)
            .backgroundColor(palette.custom.lightGray) // Alternating contrast from pure white container
            .border(1.px, org.jetbrains.compose.web.css.LineStyle.Solid, palette.custom.divider).transition(
                Transition.of("transform", 0.3.s), Transition.of("box-shadow", 0.3.s)
            )
    }
    hover {
        Modifier.translateY((-6).px)
            .boxShadow(0.px, 12.px, 30.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.08f))
    }
}